/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set A,Set B
apple,banana
banana,cherry
cherry,date`)
};

const es_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto A,Conjunto B
manzana,plátano
plátano,cereza
cereza,dátil`)
};

const de_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menge A,Menge B
apple,banana
banana,cherry
cherry,date`)
};

const nl_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set A,Set B
apple,banana
banana,cherry
cherry,date`)
};

const fr_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensemble A,Ensemble B
pomme,banane
banane,cerise
cerise,date`)
};

const it_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insieme A,Insieme B
mela,banana
banana,ciliegia
ciliegia,data`)
};

const pt_br2_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto A,Conjunto B
maçã,banana
banana,cereja
cereja,data`)
};

const pt_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto A,Conjunto B
maçã,banana
banana,cereja
cereja,tâmara`)
};

const ja_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set A,Set B
apple,banana
banana,cherry
cherry,date`)
};

const zh_venn_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集合 A,集合 B
apple,banana
banana,cherry
cherry,date`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_placeholder", locale)
	if (locale === "en") return en_venn_placeholder(inputs)
	if (locale === "es") return es_venn_placeholder(inputs)
	if (locale === "de") return de_venn_placeholder(inputs)
	if (locale === "nl") return nl_venn_placeholder(inputs)
	if (locale === "fr") return fr_venn_placeholder(inputs)
	if (locale === "it") return it_venn_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_venn_placeholder(inputs)
	if (locale === "pt") return pt_venn_placeholder(inputs)
	if (locale === "ja") return ja_venn_placeholder(inputs)
	return zh_venn_placeholder(inputs)
};